import router from "../router";
// 引用axios
var axios = require('axios');
var qs = require('qs');


// 自定义判断元素类型JS
function toType(obj) {
  return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
}
// 参数过滤函数
function filterNull(o) {
  for (var key in o) {
    if (o[key] === null) {
      delete o[key];
    }
    if (toType(o[key]) === 'string') {
      o[key] = o[key].trim();
    }
    else if (toType(o[key]) === 'object') {
      o[key] = filterNull(o[key]);
    }
    else if (toType(o[key]) === 'array') {
      o[key] = filterNull(o[key]);
    }
  }
  return o;
}
// 接口处理函数
function apiAxios(method, url, params,callback) {
  if (params) {
    params = filterNull(params);
  }
  window.token = localStorage.getItem('token')
  return axios({
    method: method,
    url: url,
    data: method === 'POST' || method === 'PUT' ? qs.stringify(params) : null,
    params: method === 'GET' || method === 'DELETE' ? params : null,
    baseURL: process.env.API_ROOT,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Token': window.token || '',
    },
  }).then(
    res=> {
      if (res.data.code == 1002 || res.data.code == 1003 || res.data.code == 1004) {
        localStorage.removeItem('token')
        localStorage.setItem('loginTip', true)
        location.reload()
      } else if (res.data.code == 1005) {
        vm.$confirm('用户未认证，点击确认去往认证页面')
          .then(_ => {
            router.push({path: '/usercenter'});
          })
          .catch(_ => {});
      } else {
        callback(res.data)
      }
    }
  )
}

// 返回在vue模板中的调用接口
export default {
  get: function (url, params, callback) {
    return apiAxios('GET', url, params,callback);
  },
  post: function (url, params, callback) {
    return apiAxios('POST', url, params,callback);
  },
  postFile: function (url, params, callback) {
    let formData = new FormData();
    for (let key of Object.keys(params)) {
      formData.append(key, params[key]);
    }
    window.token = localStorage.getItem('token')
    axios.post(url, formData, {
      baseURL: process.env.API_ROOT,
      headers: {
        'Content-Type': 'multipart/form-data',
        'Token': window.token || '',
      }
    }).then(function (res) {
      if (res.data.code == 1002 || res.data.code == 1003) {
        localStorage.removeItem('token')
        localStorage.setItem('loginTip', true)
        location.reload()
      } else {
        callback(res.data)
      }
    }).catch(function (err) {
      if (err.response) {
        console.log('请求错误');
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/index.js